import { render, staticRenderFns } from "./HandleModal.vue?vue&type=template&id=5582a086&scoped=true&"
import script from "./HandleModal.vue?vue&type=script&lang=js&"
export * from "./HandleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5582a086",
  null
  
)

export default component.exports